import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LoginPromptToastStyles from './style/LoginPromptToastPeriod.module.css'; 

const LoginPromptToast = ({ signInRedirect }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const handleLoginClick = () => {
        // 맥킨지 제언: 사용자의 현재 분석 문맥(Context)을 유지하기 위해 URL 전체를 저장합니다.
        const returnUrl = location.pathname + location.search;
        
        if (signInRedirect) {
            // OIDC 또는 라이브러리 기반 리다이렉트 시 상태 값 전달
            signInRedirect({ state: { returnUrl } });
        } else {
            // 일반적인 라우터 기반 이동 시 state 전달
            navigate('/login', { state: { returnUrl } });
        }
    };

    return (
        <div className={LoginPromptToastStyles.toastContainer}>
            <div className={LoginPromptToastStyles.content}>
                <h4 className={LoginPromptToastStyles.title}>
                    {t("LoginPromtToast.backtest.title")}
                </h4>
                <p className={LoginPromptToastStyles.description}>
                    {t("LoginPromtToast.backtest.description1")}<br />
                    {/* HTML 태그(strong)가 포함된 번역은 아래와 같이 처리하여 강조 효과를 유지합니다. */}
                    <span dangerouslySetInnerHTML={{ __html: t("LoginPromtToast.backtest.description2") }} />
                </p>
                {/* 브라우저 안내 문구 추가 */}
                <p className={LoginPromptToastStyles.browserNotice}>
                    {t("LoginPromtToast.backtest.browser_notice")}
                </p>
            </div>
            <div className={LoginPromptToastStyles.actionArea}>
                <button 
                    className={LoginPromptToastStyles.loginButton} 
                    onClick={handleLoginClick}
                >
                    {t("LoginPromtToast.backtest.button")}
                </button>
            </div>
        </div>
    );
};

export default LoginPromptToast;